import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { FORM_PESO_CON_REMITO } from '../../../../config/forms'
import { formValueSelector, reduxForm } from 'redux-form'
import { toast } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import PesadoConRemitoNumero from '../../components/pesadoConRemito/PesadoConRemitoNumero'
import PesadoConRemitoCampos from '../../components/pesadoConRemito/PesadoConRemitoCampos'
import PesadoConRemitoPeso from '../../components/pesadoConRemito/PesadoConRemitoPeso'
import InterfazEnDesarrollo from '../../../Utils/containers/InterfazEnDesarrollo'
import { buscarRemitoBruto, resetRemito, submitAltaRemito, submitPesoBrutoRemito, cargaManualUpdateEntities, updateAltaRemito, requestPesoBruto, deleteDatosRemito } from '../../actions'

const EXPORTADOR_HABITUAL = 'BUNGE ARGENTINA S A - 30700869918'

function PesadoConRemito (props) {
  const { numero, remito, pesaje, tipoPesado, modo } = props
  const [seconds, setSeconds] = useState(0)
  const [step, setStep] = useState(0)
  const [pesoConfirmado, setPesoConfirmado] = useState(false)
  const [datosPrecarga, setDatosPrecarga] = useState(false)

  const prepareEntities = (values) => {
    const { razonSocialExportador, chofer, cerealVariedad } = values
    return {
      searchSet: [
        { entity: 'exportador', value: razonSocialExportador },
        { entity: 'chofer', value: chofer },
        { entity: 'cerealVariedad', value: cerealVariedad }
      ],
      fields: ['exportador', 'chofer']
    }
  }

  useEffect(() => {
    const { change: formChange, cerealRemito, variedadRemito } = props

    if (!datosPrecarga && step === 1) {
      if (remito && remito.pesoBruto) {
        toast.error(`El remito ${remito.nroComprobanteOrigen} ya fue pesado en bruto`, { autoClose: false })
        setStep(0)
        setDatosPrecarga(false)
        formChange('numero', '')
      } else if (remito && remito.cereal) {
        console.log('remito ', remito)
        formChange('cereal', remito.claveCereal)
        formChange('cerealVariedad', remito.cerealVariedad)
        formChange('numero', remito.nroComprobanteOrigen)
        formChange('exportador', remito.cuitExportador)
        formChange('camion', remito.camion)
        formChange('acoplado', remito.acoplado)
        formChange('netoOrigen', remito.netoOrigen)
        formChange('brutoOrigen', remito.brutoOrigen)
        props.cargaManualUpdateEntities(prepareEntities(remito), formChange)
        setDatosPrecarga(true)
      } else if (cerealRemito) {
        formChange('cereal', cerealRemito)
        if (variedadRemito) {
          formChange('cerealVariedad', variedadRemito)
        }
        setDatosPrecarga(true)
      }
    }

    const interval = setInterval(async () => {
      if (tipoPesado === 'Pesado subproducto' && pesaje === 'auto') {
        const pesoCabezal = await props.requestPesoBruto()
        formChange('pesoBruto', pesoCabezal && pesoCabezal)
        formChange('balanza', props.balanza)
      }
    }, [INTERVALO_CORTO])

    const intervalTime = setInterval(() => {
      if (seconds > 0 && pesoConfirmado) {
        setSeconds(seconds - 1)
      }
      if (seconds === 0 && pesoConfirmado) {
        setPesoConfirmado(false)
        console.log('reset')
        setStep(0)
        setDatosPrecarga(false)
        formChange('numero', '')
      }
    }, [1000])

    return () => {
      clearInterval(interval)
      clearInterval(intervalTime)
    }
  }, [props, pesaje, remito, tipoPesado, datosPrecarga, step, seconds, setSeconds, pesoConfirmado, setPesoConfirmado, props.cerealRemito, props.variedadRemito])

  const nextStep = () => {
    setStep(step + 1)
  }

  // 3ro: se guarda el peso bruto de un remito
  const submitPesoRemito = () => {
    const { change: formChange, pesoMinimo, pesoBruto } = props
    formChange('numero', props.numeroRemito)
    formChange('cereal', props.cerealRemito)
    formChange('planta', props.plantaRemito)
    // se controla que el peso sea mayor al mínimo
    if (pesoBruto > pesoMinimo) {
      props.submitPesoBrutoRemito()
      toast.info('Procesando datos...')
      setSeconds(2)
      setPesoConfirmado(true)
    } else if (pesoBruto < pesoMinimo) {
      toast.error('El peso es menor al mínimo')
    }
  }

  // 2do: se cargan datos relacionados al remito y se guardan en la base
  const submitDatosRemito = () => {
    const { netoOrigen, cereal } = props
    if (cereal && cereal !== '' && cereal !== 'UNDEF') {
      if (netoOrigen !== '') {
        if (remito && remito.cereal) {
          props.updateAltaRemito()
        } else {
          console.log('no existe, hay que crear uno nuevo')
          props.submitAltaRemito()
        }
        nextStep()
      } else {
        toast.error('El peso neto de origen es un campo obligatorio, debe ingresarlo')
      }
    } else {
      toast.error('El producto es un dato obligatorio, debe seleccionar uno')
    }
  }

  // 1er: se carga exportador, nombre de planta y numero de remito
  const submitRemito = (e) => {
    const { exportador, planta, change: formChange } = props
    e.preventDefault()
    if (!isNaN(numero)) {
      if (numero && (String(numero).length > 4) && exportador !== '') {
        props.buscarRemitoBruto(numero, exportador, planta)
        nextStep()
      } else if (numero === '') {
        toast.error('Debe ingresar el número de remito')
      } else if (exportador === '') {
        toast.error('Debe seleccionar un exportador')
      } else if (planta === '') {
        toast.error('Debe seleccionar o ingresar una planta')
      } else {
        toast.error('El número de remito debe contener por lo menos 5 dígitos')
        formChange('numero', '')
      }
    } else {
      toast.error('Número inválido')
      formChange('numero', '')
    }
  }

  const resetPesado = () => {
    const { change: formChange } = props
    setStep(0)
    setDatosPrecarga(false)
    formChange('numero', '')
  }

  const precargaInicial = () => {
    const { change: formChange } = props
    if (props.exportadorRemito && props.plantaRemito) {
      formChange('exportador', props.exportadorRemito)
      formChange('planta', props.plantaRemito)
      formChange('cereal', props.cerealRemito)
      formChange('cerealVariedad', props.variedadRemito)
    }
  }

  const resetPlanta = () => {
    const { change: formChange } = props
    formChange('planta', '')
  }

  const deleteRemito = () => {
    const { exportador } = props
    props.deleteDatosRemito(numero, exportador)
    resetPesado()
  }

  const pesadoAuto = modo === 'auto'
  const enDesarrollo = false

  return (
    <>
      { enDesarrollo
        ? <InterfazEnDesarrollo />
        : <>
          { step === 0 && <PesadoConRemitoNumero
            handleSubmit={submitRemito}
            planta={props.planta}
            exportador={props.exportador}
            precargaInicial={precargaInicial}
            resetPlanta={resetPlanta}
          />
          }

          { step === 1 && <PesadoConRemitoCampos
            submitDatos={submitDatosRemito}
            resetPesado={resetPesado}
            remito={remito}
            planta={props.plantaRemito}
          />
          }

          { step === 2 && <PesadoConRemitoPeso
            handleSubmit={submitPesoRemito}
            reset={resetPesado}
            pesadoAuto={pesadoAuto}
            pesoBruto={props.pesoBruto}
            deleteRemito={deleteRemito}
          />
          }
        </>
      }
    </>
  )
}

const selector = formValueSelector(FORM_PESO_CON_REMITO)

const mapStateToProps = (state) => ({
  cereal: selector(state, 'cereal'),
  exportador: selector(state, 'exportador'),
  exportadorRemito: state.pesado.exportadorRemito,
  planta: selector(state, 'planta'),
  plantaRemito: state.pesado.plantaRemito,
  cerealRemito: state.pesado.cerealRemito,
  variedadRemito: state.pesado.variedadRemito,
  chofer: selector(state, 'chofer'),
  modo: state.pesado.pesajeBruto,
  id: selector(state, 'id'),
  netoOrigen: selector(state, 'netoOrigen'),
  numero: selector(state, 'numero'),
  numeroRemito: state.pesado.numeroRemito,
  pesoBruto: selector(state, 'pesoBruto'),
  pesoMaximo: state.pesado.pesoMaximo,
  pesoMinimo: state.pesado.pesoMinimo,
  precarga: state.pesado.precargaDatos || {},
  balanza: state.pesado.balanzaBruto,
  remito: state.pesado.consultaRemito || {}
})

const mapActionsToProps = {
  buscarRemitoBruto,
  resetRemito,
  submitAltaRemito,
  submitPesoBrutoRemito,
  cargaManualUpdateEntities,
  updateAltaRemito,
  requestPesoBruto,
  deleteDatosRemito
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_PESO_CON_REMITO,
  initialValues: {
    pesoBruto: '',
    numero: '',
    netoOrigen: '',
    planta: '',
    exportador: EXPORTADOR_HABITUAL,
    cerealVariedad: 'UNDEF   '
  }
})

export default withRedux(withReduxForm(PesadoConRemito))
